import React, { useEffect } from 'react'

//Import Images
import gpsTracking from "../../../assets/images/gpsTracking.png"
import miningGps from "../../../assets/images/miningGps.png"

//Import AOS
import AOS from "aos";
import "aos/dist/aos.css";

const GpsService = () => {
    useEffect(() => {
            AOS.init({
              duration: 1000, // Animation duration in milliseconds
              once: false,
              offset: 100,  // Trigger when the element is 100px from the viewport
          delay: 200, // Whether animation should happen only once
            });
          }, []);

  return (
    <div id='gps' className='mt-12 lg:mt-20'>

        {/* Section Heading */}
        <div className='text-center' data-aos="fade-up">
            <h1 className='text-[#252525] font-bold text-2xl md:text-4xl xl:text-5xl oxygen'>
                Gps Service
            </h1>
            <p className='text-[#868686] text-sm md:text-base lg:text-lg xl:text-xl px-6 md:px-12 lg:px-36 xl:px-48 my-4 md:my-8'>
                GPS Service refers to solutions that leverage Global Positioning System (GPS) technology to provide real-time location tracking, navigation, and mapping capabilities. These services are widely used across industries for purposes such as vehicle tracking, fleet management, personal navigation, outdoor activities, and logistics optimization.
            </p>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 w-full mt-12'>
            <div data-aos="fade-right">
                <img src={gpsTracking} alt="" className='w-full h-full' />
            </div>
            <div className='bg-[#E9FFF2] px-6 md:px-12 flex flex-col justify-center' data-aos="fade-left">
                <h2 className='text-[#F26422] font-bold text-xl md:text-2xl xl:text-3xl oxygen mb-4'>
                    Tracking GPS
                </h2>
                <p className='text-[#363533] text-sm md:text-base lg:text-lg xl:text-xl'>
                    Tracking GPS refers to the use of Global Positioning System (GPS) technology to monitor and record the location of objects, vehicles, or individuals in real time. It relies on GPS satellites to determine precise geographical coordinates, which are then transmitted to a central system or device for tracking and analysis.
                </p>
            </div>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 w-full mt-12'>
            <div className='bg-[#FFF1F1] px-6 md:px-12 flex flex-col justify-center' data-aos="fade-right">
                <h2 className='text-[#F26422] font-bold text-xl md:text-2xl xl:text-3xl oxygen mb-4'>
                    Mining GPS
                </h2>
                <p className='text-[#363533] text-sm md:text-base lg:text-lg xl:text-xl'>
                    Mining GPS refers to the use of Global Positioning System (GPS) technology in the mining industry to enhance efficiency, safety, and accuracy in operations. It involves integrating GPS-enabled systems into mining equipment, vehicles, and monitoring tools to track, manage, and optimize various aspects of mining activities.
                </p>
            </div>
            <div data-aos="fade-left">
                <img src={miningGps} alt="" className='w-full h-full' />
            </div>
        </div>
    </div>
  )
}

export default GpsService